import { useActivateAllChats, useChats, useInactiveChatsCount } from "../../Domain/chats";
import { ChatListItem } from "./ChatListItem";
import { useParams } from "react-router-dom";
import { useState } from "react";
import styled from "styled-components";
import { ChatDetails } from "./ChatDetails";
import { Colors } from "../Styles/ColorPalette";
import PrimaryButton from "../SharedComponents/PrimaryButton";
import { Banner } from "../SharedComponents/Banner";

const ChatsPage = () => {
  const { data: chats, isLoading, error } = useChats();
  const { chatId } = useParams();
  const [showMoreChats, setShowMoreChats] = useState(false);

  const sortedChats = (chats ?? []).sort((a, b) => {
    if (!a.lastMessageTime && !b.lastMessageTime) {
      return 0;
    }
    if (!a.lastMessageTime) {
      return 1;
    }
    if (!b.lastMessageTime) {
      return -1;
    }
    const timeA = new Date(a.lastMessageTime).getTime();
    const timeB = new Date(b.lastMessageTime).getTime();
    return timeB - timeA;
  });

  const showMore = () => setShowMoreChats(true);
  const chatsList = showMoreChats ? sortedChats : sortedChats.slice(0, 30);

  const { data: inactiveCount } = useInactiveChatsCount();

  const activateAllChatsMutation = useActivateAllChats();

  const onActivateClick = async () => {
    await activateAllChatsMutation.mutate(true);
  }

  return (
    <ChatsPageContainer>
      {isLoading && <Banner variant="warning">Loading...</Banner>}
      {error && <Banner variant="error">{error?.message}</Banner>}
      <ChatsContainer>
        <ChatsListContainer>

          {!isLoading && !error && (
            <InactiveChatsContainer>
              <InactiveChats $inactiveCount={inactiveCount}>
              Inactive chats: {inactiveCount}
                {/*Activating: {activatingAllChats ? 'Yes' : 'No'}*/}
              </InactiveChats>
              <PrimaryButton
                onClick={onActivateClick}
                disabled={activateAllChatsMutation.isPending}
              >Activate</PrimaryButton>
            </InactiveChatsContainer>
          )}

          {chatsList && chatsList.map(chat => <ChatListItem key={chat.chatId} {...chat} />)}
          {sortedChats.length > 30 && (
            <PrimaryButton onClick={showMore} margin="12px">Show More</PrimaryButton>
          )}
        </ChatsListContainer>
        <ChatDetailsWrapper>
          {chatId && <ChatDetails/>}
        </ChatDetailsWrapper>
      </ChatsContainer>
    </ChatsPageContainer>
  );
}


const ChatsPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background-color: white;
    height: 100%;
    overflow: hidden;
`;

const ChatsContainer = styled.div`
    display: flex;
    flex-grow: 1;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

const ChatsListContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    flex-shrink: 0;
    width: 24rem;
    overflow-y: auto;
    border-right: 1px solid ${Colors.border.primary};
`;

const InactiveChatsContainer = styled.div`
    padding: 8px;
    padding-left: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid ${Colors.border.primary};
`;

const InactiveChats = styled.div<{ $inactiveCount: number }>`
    color: ${props => props.$inactiveCount > 0 ? 'red' : 'inherit'};
    padding-top: 8px;
    //font-weight: ${props => props.$inactiveCount > 0 ? 'bold' : 'normal'};
`;

const ChatDetailsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100%;
    background-color: ${Colors.background.chat};
`;

export default ChatsPage;
